import { c as _c } from "react/compiler-runtime";
import { MembersLayout } from '@src/components/sco/Members/MembersLayout';
import { MemberProfileNav } from '@src/components/sco/Members/MembersLayout/MemberProfileNav';
import { MembersMainPanel } from '@src/components/sco/Members/MembersLayout/MembersMainPanel';
import { UserProfile } from '@src/components/sco/Members/UserProfile';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { useParams } from 'next/navigation';
import React, { ReactElement } from 'react';

// L7: 404 for an unknown slug/id, 410 for a profile this viewer may not see (cookies forwarded).
export { memberProfileGetServerSideProps as getServerSideProps } from '@src/lib/memberProfileServerSideProps';
function Page() {
  const $ = _c(4);
  const params = useParams();
  const activeContent = useActiveContentContext();
  let t0;
  if ($[0] !== activeContent) {
    t0 = () => {
      activeContent.setSiteSection("members.single");
    };
    $[0] = activeContent;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useUniversalEffect(t0);
  const t1 = `${params.memberSlug}`;
  let t2;
  if ($[2] !== t1) {
    t2 = <MembersMainPanel><UserProfile manageSeo={true} userSlug={t1} /></MembersMainPanel>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}

// Approved advisors get the Advisors rail here (walk #7); everyone else the Members rail.
Page.getLayout = (page: ReactElement) => <MembersLayout mainPanel={page} navPanel={<MemberProfileNav />} />;
export default Page;